interface OtherMainContentProps {
    parkingImage: string | null;
}

export default function OtherMainContent({ parkingImage }: OtherMainContentProps) {
    return (
        <main className="widescreen:px-[calc(104*var(--vw-unit))] widescreen:pb-[calc(64*var(--vh-unit))] h-full w-full overflow-auto px-[calc(104*var(--vw-unit))] pt-[calc(72*var(--vh-unit))] pb-[calc(208*var(--vh-unit))]">
            <img src={parkingImage || ''} alt="Parking information" className="fullscreen:object-contain fullscreen:h-full fullscreen:w-full" />
        </main>
    );
}
